import { useState } from "react";

export interface ListState {
  search: string;
  page: number;
  limit: number;
  sortBy: string;
  order: "asc" | "desc";
  filters: Record<string, any>;
}

export function useListState(initial?: Partial<ListState>) {
  const [state, setState] = useState<ListState>({
    search: "",
    page: 1,
    limit: 10,
    sortBy: "createdAt",
    order: "desc",
    filters: {},
    ...initial,
  });

  return {
    ...state,
    setSearch: (v: string) => setState((s) => ({ ...s, search: v, page: 1 })),
    setPage: (p: number) => setState((s) => ({ ...s, page: p })),
    setLimit: (l: number) => setState((s) => ({ ...s, limit: l, page: 1 })),
    setSort: (sortBy: string, order: "asc" | "desc") => setState((s) => ({ ...s, sortBy, order, page: 1 })),
    setFilter: (key: string, value: any) =>
      setState((s) => ({ ...s, filters: { ...s.filters, [key]: value }, page: 1 })),
    queryParams: () => ({
      search: state.search || undefined,
      page: state.page,
      limit: state.limit,
      sortBy: state.sortBy,
      order: state.order,
      ...state.filters,
    }),
  };
}
